import { AdvancedFilterType } from '@/enums/AdvancedFilterType'
import type { ITableHeader } from '@/interfaces/ITableHeader'
import { type Composer } from 'vue-i18n'

export const getTableHeaders = (
  i18n: Composer<{}, {}, {}, string, never, string>
): Array<ITableHeader> => {
  return [
    {
      title: i18n.t('fields.people.lastName'),
      key: 'lastName',
      align: 'start',
      nowrap: true,
      headerProps: { filterType: AdvancedFilterType.Text, searchField: true }
    },
    {
      title: i18n.t('fields.people.firstName'),
      key: 'firstName',
      align: 'start',
      nowrap: true,
      headerProps: { filterType: AdvancedFilterType.Text, searchField: true }
    },
    {
      title: i18n.t('fields.people.idNumber'),
      key: 'idNumber',
      align: 'start',
      nowrap: true,
      headerProps: { filterType: AdvancedFilterType.Text, searchField: true }
    },
    {
      title: i18n.t('fields.people.email'),
      key: 'email',
      align: 'start',
      nowrap: true,
      headerProps: { filterType: AdvancedFilterType.Text, searchField: true }
    }
  ]
}
